<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-26 16:25:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-20 18:37:51
-->
<template>
	<el-dialog title="团长重新授权提示" :visible.sync="visible" :show-close="false" :close-on-click-modal="false" width="400px">
		<div class="ml-8 mt-8 mr-8 yx-color-black1">
			<i class="el-icon-warning"></i>
			由于抖音官方调整，需要您所在的团队重新授权团长账号，授权后可正常使用系统。 请联系团队管理员重新进行账号授权！
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="closeDialog">关闭</el-button>
			<el-button type="primary" @click="refresh">已重新授权，刷新页面</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { getAuthStatus } from '@/api/home';
export default {
	props: {},
	name: 'notice',
	data() {
		return {
			visible: false,
		};
	},
	computed: {},
	methods: {
		show() {
			this.visible = true;
		},

		refresh() {
			this.getAuthStatus();
		},
		closeDialog() {
			this.visible = false;
		},
		async getAuthStatus() {
			const { auth, newAuth, isManager } = await getAuthStatus();
			if (!auth) return; //未授权
			if (newAuth) return; //是否授权新应用
			if (isManager) {
				this.visible = false;
			} else {
				this.visible = true;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.el-icon-warning {
	color: #ff7038;
}
</style>
